import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Tooltip,
  Divider,
  Box,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  Paper,
  Pagination,
  Modal,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  DialogActions,
  Stack,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { getCurrencySymbol, showToast, WEBSERVICE } from "../../CoreDataService";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Col } from "react-bootstrap";
import DataTable from "../../Common/DataTable";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";
import ModalContent from "../../Common/Modal";

const DepositPage = () => {
  const { userInfo, btncolor } = useSelector((state) => state);
  const navigate = useNavigate();
  const theme = useTheme();
  const themeColor = localStorage.getItem("theme");
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  console.log("isMobile", isMobile);

  const [invoiceList, setInvoiceList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [noOfItemsPerPage] = useState(20);
  const [adminBankDetails, setAdminBankDetails] = useState([]);
  const [banks, setBanks] = useState([]);

  const [environmentSettings, setEnvironmentSettings] = useState({});
  const [tierWiseLimits, setTierWiseLimits] = useState({ byId: {}, byCode: {} });

  const [userBalanceList, setUserBalanceList] = useState([]);
  const [fiatCurrencyList, setFiatCurrencyList] = useState([]);
  const [selectedCryptoCurrency, setSelectedCryptoCurrency] = useState("");
  const [currencyBalance, setCurrencyBalance] = useState([]);
  const [environmentSettingListObj, setEnvironmentSettingListObj] = useState(
    {}
  );

  const [currencyCode, setCurrencyCode] = useState("");
  const [currencyValue, setCurrencyValue] = useState(0);
  const [currencyId, setCurrencyId] = useState("");
  const [depositAmount, setDepositAmount] = useState("");
  const [selectedBankId, setSelectedBankId] = useState("");

  const [isDepositModalOpen, setIsDepositModalOpen] = useState(false);

  const [bankDetails, setBankDetails] = useState([]); // assuming this is filled via API
  const [selectedBank, setSelectedBank] = useState(null);
  const [showSwift, setShowSwift] = useState(false);

  const [displableOrderNo, setDisplableOrderNo] = useState("");
  const [invoiceAmountI, setInvoiceAmountI] = useState("");
  const [displableBankName, setDisplableBankName] = useState("");
  const [displableAccNo, setDisplableAccNo] = useState("");
  const [displableRoutingNo, setDisplableRoutingNo] = useState("");
  const [displableBeneficiaryName, setDisplableBeneficiaryName] = useState("");
  const [displableSwiftCode, setDisplableSwiftCode] = useState("");
  const [displableIntermediaryBankName, setDisplableIntermediaryBankName] = useState("");
  const [displableIntermediaryBankSwiftCode, setDisplableIntermediaryBankSwiftCode] = useState("");
  const [displayableCurrencyCode, setDisplayableCurrencyCode] = useState("");
  const [displableIbanNo, setDisplableIbanNo] = useState("");
  const [displableIfscCode, setDisplableIfscCode] = useState("");
  const [displableAccountType, setDisplableAccountType] = useState("");
  const [displableBankAddress, setDisplableBankAddress] = useState("");
  const [displableBeneficiaryAddress, setDisplableBeneficiaryAddress] =
    useState("");
  const [displableSortCode, setDisplableSortCode] = useState("");
  const [referencenumber, setRefferenceNumber] = useState("");
  const [note, setNote] = useState("");
  const [showSwiftCode, setShowSwiftCode] = useState(false);
  const [showPaymentOrderModal, setShowPaymentOrderModal] = useState(false);

  const [showInvoice, setShowInvoice] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [isDisabledByCountry, setIsDisabledByCountry] = useState(true);
  const [showIncreaseLimit, setShowIncreaseLimit] = useState(false);
  const [dipositeBankWarning, setDipositeBankWarning] = useState(false);
  const [verificationTitle, setVerificationTitle] = useState("");
  const [verificationText, setVerificationText] = useState("");
  const [userDetails, setUserDetails] = useState();

  const getCurrentLimits = (cId = currencyId, cCode = currencyCode) => {
    const limit =
      tierWiseLimits.byId?.[cId] ||
      tierWiseLimits.byCode?.[cCode?.toUpperCase()] ||
      {};
    const min =
      limit.minLimit !== undefined && limit.minLimit !== null && limit.minLimit !== ""
        ? parseFloat(limit.minLimit)
        : 0;
    const max =
      limit.maxLimit !== undefined && limit.maxLimit !== null && limit.maxLimit !== ""
        ? parseFloat(limit.maxLimit)
        : Infinity;
    return {
      min: isNaN(min) ? 0 : min,
      max: isNaN(max) ? Infinity : max,
      rawMin: limit.minLimit ?? "0",
      rawMax: limit.maxLimit ?? "N/A",
    };
  };

  const openInvoice = (data) => {
    console.log("dataaa", data);

    const bankInfo = adminBankDetails?.find((b) => b.bankId == data.bankId) || {};

    setInvoiceData({
      invoiceOrderNoI: data.order_no,
      invoiceAmountI: data.amount,
      bankNameI: data.bankName,
      accountNoI: data.accountNo,
      routingNoI: data.routingNo,
      beneficiaryNameI: data.beneficiaryName,
      swiftCodeI: data.swiftCode,
      currencynameI: data.currency,
      ibanNoI: data.ibanNo,
      ifscCodeI: data.ifscCode,
      accountTypeI: data.accountType,
      sortCodeI: data.sortCode,
      currency: data.currency,
      bankAddressI: data.bankAddress,
      beneficiaryAddressI: data.beneficiaryAddress,
      referenceNumberI: data.referenceNumber,
      noteI: data.note,
      intermediaryBankNameI: bankInfo.intermediaryBankName || "",
      intermediaryBankSwiftCodeI: bankInfo.intermediaryBankSwiftCode || "",
    });

    setShowInvoice(true);
  };

  const closeInvoice = () => {
    setShowInvoice(false);
    setInvoiceData(null);
  };

  const getUserTransaction = async () => {
    try {
      const userTransObj = {
        customerId: localStorage.getItem("user_id"),
        uuid: localStorage.getItem("uuid"),
      };

      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserBalance`,
        JSON.stringify(userTransObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;

      if (result.error?.error_data !== 0) {
        showToast("danger", "Cannot fetch user balance");
        console.log("Fetching User balance failed");
        return;
      }

      const balanceList = result.userBalanceList || [];
      setUserBalanceList(balanceList);
      setCurrencyBalance(balanceList);

      // Set fiat currency list
      const fiatList = balanceList.filter(
        (item) => item.currencyType === "1" || item.currencyType === 1
      );
      console.log("fiatList", fiatList);

      setFiatCurrencyList(fiatList);

      // Set selected currency
      setSelectedCryptoCurrency(localStorage.getItem("selected_currency"));

      // Get environment settings from localStorage
      const envSettingsStr = localStorage.getItem("environment_settings_list");
      if (envSettingsStr) {
        setEnvironmentSettingListObj(JSON.parse(envSettingsStr));
      }
    } catch (error) {
      if (error?.response?.status === 401 || error?.response?.status === 400) {
        showToast("warning", "Session Timeout. Login Again");
        // logout logic here
      }
    }
  };

  const fetchPaymentOrders = async (page) => {
    try {
      const paymentOrderObj = {
        uuid: localStorage.getItem("uuid"),
        pageNo: page,
        noOfItemsPerPage: noOfItemsPerPage,
      };

      const response = await axios.post(
        `${WEBSERVICE}transaction/getInvoicesList`,
        JSON.stringify(paymentOrderObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;
      console.log("shhhshhhs", result);

      if (result.error?.error_data === 0) {
        setInvoiceList(result.invoicesListResult || []);
        setTotalCount(result.totalCount || 0);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        // handle logout
      }
    }
  };

  const getAdminBankDetails = async () => {
    try {
      const bankDetailsObj = {
        userId: localStorage.getItem("user_id"),
      };

      const response = await axios.post(
        `${WEBSERVICE}user/GetAdminBankDetails`,
        JSON.stringify(bankDetailsObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;

      if (result.error !== "") {
        showToast("error", "Error fetching bank details");
      } else {
        const details = result.adminBankDetails || [];
        setAdminBankDetails(details);

        const formattedBanks = details.map((item) => ({
          bankname: item.bankName,
          bankId: item.bankId,
        }));
        setBanks(formattedBanks);
      }
    } catch (error) {
      showToast("warning", "SESSION TIMED OUT. LOGIN AGAIN");
      // logout logic here if needed
    }
  };

  const appSettingsCall = async () => {
    try {
      const uuid = localStorage.getItem("uuid");
      const infoObj = { uuid };
      const response = await axios.post(
        `${WEBSERVICE}user/GetUserAppSettings`,
        JSON.stringify(infoObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;

      if (result.error?.error_data !== 0) return;

      // Save user app settings
      localStorage.setItem(
        "user_app_settings_list",
        JSON.stringify(result.userAppSettingsResult)
      );

      if (
        result.userAppSettingsResult.user_docs_status == "" ||
        result.userAppSettingsResult.user_docs_status == null ||
        result.userAppSettingsResult.user_docs_status == "2"
      ) {
        setShowIncreaseLimit(true);
      } else {
        setShowIncreaseLimit(false);
      }

      // Construct environmentSettingsListObj
      const settingsList = result.settingsList || [];
      const envSettings = {};
      settingsList.forEach((item) => {
        envSettings[`${item.name}${item.currencyId}`] = item;
      });
      localStorage.setItem(
        "environment_settings_list",
        JSON.stringify(envSettings)
      );
      setEnvironmentSettings(envSettings);

      const tierType = userDetails?.userTierType;
      const tierSettings = result.tierWiseTransactionSettingsList || [];
      console.log("tierType", tierType);
      const limitsById = {};
      const limitsByCode = {};
      tierSettings.forEach((item) => {
        if (item.tierType === tierType) {
          const limitData = {
            minLimit: item.minLimit,
            maxLimit: item.dailySendLimit,
            dailySendLimit: item.dailySendLimit,
          };
          if (item.currencyId !== undefined && item.currencyId !== null) {
            limitsById[item.currencyId] = limitData;
          }
          if (item.currencyCode) {
            limitsByCode[item.currencyCode.toUpperCase()] = limitData;
          }
        }
      });
      setTierWiseLimits({ byId: limitsById, byCode: limitsByCode });
    } catch (error) {
      if (error?.response?.status === 401) {
        showToast("warning", "SESSION TIMED OUT. LOGIN AGAIN");
        // logout logic if needed
      }
    }
  };

  const handlePageChange = (_, newPage) => {
    setPageNo(newPage);
    fetchPaymentOrders(newPage);
  };

  useEffect(() => {
    fetchPaymentOrders(pageNo);
    getAdminBankDetails();

    getUserTransaction();
    getUserDetails();
  }, []);
  useEffect(() => {
    if (userDetails) {
      appSettingsCall();
    }
  }, [userDetails]);

  const [selectedCurrency, setSelectedCurrency] = useState(null);


  const getUserDetails = async () => {
    const uuid = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");
    const userId = localStorage.getItem("userId");
    const data = {
      userId: userId,
      uuid: uuid,
    };
    try {
      const response = await axios.post(
        `${WEBSERVICE}user/GetUserDetails`,
        data,
        {
          headers: {
            Authorization: `BEARER ${token}`, // Include the token in the Authorization header
          },
        }
      );
      setUserDetails(response?.data?.userResult);
    } catch (err) {
      showToast("error", err?.response?.data?.error?.error_msg);
    }
  };

  const getDepositModal = (elem, bal, cId) => {
    console.log(elem, bal, cId);

    if (userBankVerificationStatus()) {
      if (userInfo.userResult.isFiatDeposit != 1) {
        showToast("error", "Deposit operation is restricted in your account");
      } else {
        setCurrencyCode(elem);
        setCurrencyValue(bal);
        setCurrencyId(cId);
        setDepositAmount("");
        localStorage.setItem("currencyId", cId);

        const selectedBank = adminBankDetails.find(
          (bank) =>
            bank.currencyId === cId ||
            bank.currencyId == cId ||
            bank.currencyCode?.toUpperCase() === elem?.toUpperCase() ||
            bank.currency?.toUpperCase() === elem?.toUpperCase()
        );
        console.log("selectedBank", selectedBank);

        if (selectedBank) {
          setSelectedBankId(selectedBank.bankId);
          getBankDetails(selectedBank.bankId);
          setIsDepositModalOpen(true);

          setDisplableBankName(selectedBank.bankname || selectedBank.bankName || "");
          setDisplableAccNo(selectedBank.accountNo || "");
          setDisplableRoutingNo(selectedBank.routingNo || "");
          setDisplableBeneficiaryName(selectedBank.beneficiaryName || "");
          setDisplableSwiftCode(selectedBank.swiftCode || "");
          setDisplayableCurrencyCode(selectedBank.currencyCode || selectedBank.currency || elem);
          setDisplableIbanNo(selectedBank.ibanNo || "");
          setDisplableIfscCode(selectedBank.ifscCode || "");
          setDisplableAccountType(selectedBank.accountType || "");
          setDisplableBankAddress(selectedBank.bankAddress || "");
          setDisplableBeneficiaryAddress(selectedBank.beneficiaryAddress || "");
          setDisplableSortCode(selectedBank.sortCode || "");
          setRefferenceNumber(selectedBank.referenceNumber || "");
          setNote(selectedBank.note || "");
          setDisplableIntermediaryBankName(selectedBank.intermediaryBankName || "");
          setDisplableIntermediaryBankSwiftCode(selectedBank.intermediaryBankSwiftCode || "");
        } else {
          showToast("error", `Bank details for ${elem} are not available at the moment.`);
        }
      }
    } else {
      setDipositeBankWarning(true);
    }
  };

  const isDepositDisabled = () => {
    const amount = parseFloat(depositAmount);
    if (!amount || isNaN(amount) || amount <= 0) return true;
    const { min, max } = getCurrentLimits();
    return amount < min || (max !== Infinity && amount > max);
  };

  // const selectedBank = selectedCurrency ? bankDetails[selectedCurrency] : null;

  const getBankDetails = (bankID) => {
    if (bankID === "Select Bank Name") {
      setSelectedBank(null);
      setShowSwift(false);
      return;
    }

    const selected = adminBankDetails.find((bank) => bank.bankId === bankID);

    if (selected) {
      setSelectedBank({
        accountNo: selected.accountNo,
        routingNo: selected.routingNo,
        accountType: selected.accountType,
        ibanNo: selected.ibanNo,
        ifscCode: selected.ifscCode,
        swiftCode: selected.swiftCode,
        sortCode: selected.sortCode,
        bankAddress: selected.bankAddress,
        bankName: selected.bankName,
        beneficiaryName: selected.beneficiaryName,
        beneficiaryAddress: selected.beneficiaryAddress,
        bankId: selected.bankId,
        currencyId: selected.currencyId,
        refNo: selected.referenceNumber,
        note: selected.note,
        intermediaryBankName: selected.intermediaryBankName,
        intermediaryBankSwiftCode: selected.intermediaryBankSwiftCode,
      });

      setTimeout(() => {
        console.log("selected b", selected);
      }, 10000);

      setShowSwift(!!selected.swiftCode);
      console.log("Iban:", selected.ibanNo);
      console.log("routingNo:", selected.routingNo);
      console.log("ifscCode:", selected.ifscCode);
      console.log("swiftCode:", selected.swiftCode);
      console.log("sortCode:", selected.sortCode);
    }
  };

  const handleShowPaymentOrder = (
    id,
    amount,
    bankname,
    accountNo,
    RoutingNo,
    bfnm,
    swiftCode,
    currencyCode,
    ibnNo,
    ifscCode,
    accountType,
    bankAddress,
    beneficiaryAddress,
    sortCode,
    referenceNumber,
    note,
    bankId,
    intermediaryBankName,
    intermediaryBankSwiftCode
  ) => {
    const bankInfo = adminBankDetails?.find((b) => b.bankId == bankId) || {};
    setDisplableIntermediaryBankName(intermediaryBankName || bankInfo.intermediaryBankName || "");
    setDisplableIntermediaryBankSwiftCode(intermediaryBankSwiftCode || bankInfo.intermediaryBankSwiftCode || "");
    setDisplableOrderNo(id);
    setInvoiceAmountI(amount);
    setDisplableBankName(bankname);
    setDisplableAccNo(accountNo);
    setDisplableRoutingNo(RoutingNo);
    setDisplableBeneficiaryName(bfnm);
    setDisplableSwiftCode(swiftCode);
    setDisplayableCurrencyCode(currencyCode);
    setDisplableIbanNo(ibnNo);
    setDisplableIfscCode(ifscCode);
    setDisplableAccountType(accountType);
    setDisplableBankAddress(bankAddress);
    setDisplableBeneficiaryAddress(beneficiaryAddress);
    setDisplableSortCode(sortCode);
    setRefferenceNumber(referenceNumber);
    setNote(note);

    console.log("sorttt", sortCode);

    // setShowSwiftCode(bankname === 'Bank of America');
    setShowPaymentOrderModal(true); // Open modal
  };

  const handleBankDetailsAdd = () => {
    setDipositeBankWarning(false);
    navigate("/bank-details");
  };

  const BankDetail = ({ label, value }) => (
    <Box sx={modernBankDetailRow}>
      <Typography sx={bankDetailLabel}>{label}</Typography>
      <Box sx={bankDetailValueWrap}>
        <Typography sx={bankDetailValue}>{value}</Typography>
        {value && (
          <Tooltip title="Copy" arrow>
            <IconButton
              size="small"
              sx={bankDetailCopyBtn}
              onClick={() => navigator.clipboard.writeText(value)}
            >
              <ContentCopyIcon sx={{ fontSize: 14 }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  );

  const InvoiceDetail = ({ label, value }) => (
    <Grid size={12}>
      <Box sx={label === "Note" ? { ...modernInvoiceRow, alignItems: "flex-start" } : modernInvoiceRow}>
        <Typography sx={invoiceRowLabel}>{label}</Typography>
        {label === "Note" ? (
          /<[a-z][\s\S]*>/i.test(value) ? (
            <Box sx={{ ...invoiceRowValue, textAlign: "left", flex: 1, "& h3,& h4": { margin: "6px 0 4px", fontWeight: 700 }, "& p": { margin: "4px 0" }, "& ul": { paddingLeft: "1.4em", margin: "4px 0" }, "& li": { marginBottom: "4px" }, "& strong": { fontWeight: 700 } }} dangerouslySetInnerHTML={{ __html: value }} />
          ) : (
            <Typography sx={{ ...invoiceRowValue, textAlign: "left", flex: 1, whiteSpace: "pre-line" }}>{value}</Typography>
          )
        ) : (
          <Typography sx={invoiceRowValue}>{value}</Typography>
        )}
      </Box>
    </Grid>
  );

  const userBankVerificationStatus = () => {
    const userAppSettingsObj = JSON.parse(
      localStorage.getItem("user_app_settings_list")
    );
    console.log("userAppSettingsObj", userAppSettingsObj);
    const userBankStatus = userAppSettingsObj?.bank_details_status;

    if (userBankStatus === "") {
      setVerificationTitle("Submit Payment Method");
      setVerificationText(
        "Your Payment details are not yet submitted. Please submit your Payment Details to proceed."
      );
      return false;
    } else if (userBankStatus === "0") {
      setVerificationTitle("Payment Being Verified");
      setVerificationText(
        "Your Payment details are being verified. This step will be available after verification."
      );
      return false;
    } else if (userBankStatus === "3") {
      setVerificationTitle("Submit Payment Method");
      setVerificationText(
        "Your Payment details have been disapproved. Kindly submit the details again to proceed."
      );
      return false;
    } else {
      return true;
    }
  };

  // Function to handle deposit logic
  const handleDepositAmount = async () => {
    if (!depositAmount) {
      showToast("error", "Please fill all fields properly.");
      return;
    }

    console.log("selectedCurrency", currencyCode);

    // setLoading(true); // Show loading spinner

    try {
      const { min, max, rawMin, rawMax } = getCurrentLimits();
      const amount = parseFloat(depositAmount);

      // Validate the deposit amount
      if (isNaN(amount) || amount < min || (max !== Infinity && amount > max)) {
        const symbol = getCurrencySymbol(currencyCode);
        showToast(
          "error",
          `Deposit amount must be between ${symbol} ${rawMin} and ${symbol} ${rawMax}`
        );
        return;
      }

      var userTransObj = {
        sendAmount: depositAmount,
        currencyId: currencyId,
        uuid: localStorage.getItem("uuid"),
        bankId: selectedBankId,
      };

      const response = await axios.post(
        `${WEBSERVICE}transaction/createPaymentOrder`,
        JSON.stringify(userTransObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;

      if (result.error?.error_data !== 0) {
        showToast("danger", result.error?.error_msg);
        return;
      } else {
        // showToast('success', result.error?.error_msg);
        setIsDepositModalOpen(false); // Open modal for confirmation or further action
        setDisplableOrderNo(result.paymentOrdersListResult[0].order_no);

        fetchPaymentOrders(1);

        setShowPaymentOrderModal(true); // Open modal

        // setTimeout(() => {
        //     window.location.reload();
        // }, 1000);
      }
    } catch (err) {
      showToast("error", "An error occurred while processing your request.");
      console.log("err", err);
    } finally {
      // setLoading(false);
    }
  };

  const renderStatusBadge = (status) => {
    const isConfirmed = status === 17;
    const isPending = status === 15;
    return (
      <Box
        sx={{
          ...statusBadge,
          color: isConfirmed
            ? "#16a34a"
            : isPending
              ? "#d97706"
              : "#dc2626",
          backgroundColor: isConfirmed
            ? "rgba(22,163,74,0.10)"
            : isPending
              ? "rgba(217,119,6,0.10)"
              : "rgba(220,38,38,0.10)",
          borderColor: isConfirmed
            ? "rgba(22,163,74,0.25)"
            : isPending
              ? "rgba(217,119,6,0.25)"
              : "rgba(220,38,38,0.25)",
        }}
      >
        {isConfirmed ? (
          <CheckCircleOutlineIcon sx={{ fontSize: 14 }} />
        ) : isPending ? (
          <HourglassEmptyOutlinedIcon sx={{ fontSize: 14 }} />
        ) : (
          <ErrorOutlineOutlinedIcon sx={{ fontSize: 14 }} />
        )}
        {isConfirmed ? "Confirmed" : isPending ? "Pending" : "Declined"}
      </Box>
    );
  };

  const renderFiatBalances = () => (
    <Box sx={panelCard}>
      <Box sx={panelHeader}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
          <Box sx={{ ...panelIconWrap, backgroundColor: `${btncolor}1a`, color: btncolor }}>
            <AccountBalanceWalletOutlinedIcon sx={{ fontSize: 20 }} />
          </Box>
          <Box>
            <Typography sx={panelTitle}>Fiat Balances</Typography>
            <Typography sx={panelCaption}>
              Click DEPOSIT to generate a payment order
            </Typography>
          </Box>
        </Box>
        <Tooltip title="Generate a payment order by clicking on the DEPOSIT link." arrow>
          <InfoOutlinedIcon sx={infoIconStyle} />
        </Tooltip>
      </Box>
      <Box sx={panelDivider} />

      <Box sx={fiatTableHead}>
        <Typography sx={fiatHeadCell}>Currency</Typography>
        <Typography sx={fiatHeadCell}>Balance</Typography>
        <Typography sx={{ ...fiatHeadCell, textAlign: "right" }}>Action</Typography>
      </Box>

      <Stack spacing={1}>
        {fiatCurrencyList.map((bal, i) => (
          <Box key={i} sx={fiatRow}>
            <Box sx={fiatCellLeft}>
              <Box sx={{ ...currencyAvatar, backgroundColor: `${btncolor}1a`, color: btncolor }}>
                {(bal.currencyCode || "").slice(0, 1)}
              </Box>
              <Typography sx={currencyCodeText}>{bal.currencyCode}</Typography>
            </Box>
            <Typography sx={balanceText}>{bal.closingBalance}</Typography>
            <Box sx={fiatActionCell}>
              {bal.disabledDepositByCountry == 0 ? (
                <ContainedButton
                  variant="contained"
                  size="small"
                  sx={depositActionBtn}
                  onClick={() =>
                    getDepositModal(
                      bal.currencyCode,
                      bal.closingBalance,
                      bal.currencyId
                    )
                  }
                >
                  Deposit
                </ContainedButton>
              ) : (
                <OutlinedButton
                  variant="outlined"
                  size="small"
                  disabled
                  sx={restrictedBtn}
                >
                  Restricted
                </OutlinedButton>
              )}
            </Box>
          </Box>
        ))}
        {fiatCurrencyList.length === 0 && (
          <Box sx={emptyState}>
            <InboxOutlinedIcon sx={emptyIcon} />
            <Typography sx={emptyText}>No currencies available</Typography>
          </Box>
        )}
      </Stack>
    </Box>
  );

  const renderBankDetails = () => (
    <Box sx={panelCard}>
      <Box sx={panelHeader}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
          <Box sx={{ ...panelIconWrap, backgroundColor: `${btncolor}1a`, color: btncolor }}>
            <AccountBalanceOutlinedIcon sx={{ fontSize: 20 }} />
          </Box>
          <Box>
            <Typography sx={panelTitle}>Bank Details</Typography>
            <Typography sx={panelCaption}>
              Exchange bank info for fund transfers
            </Typography>
          </Box>
        </Box>
        <Tooltip
          title="The exchange bank information is available here for depositing funds. You can transfer funds to this bank account. Once the deposit request is confirmed, the transfer will be processed, and the funds will be credited to the wallet within 1 business day."
          arrow
        >
          <InfoOutlinedIcon sx={infoIconStyle} />
        </Tooltip>
      </Box>
      <Box sx={panelDivider} />

      {selectedBank ? (
        <Stack spacing={1}>
          <BankDetail label="Beneficiary Name" value={selectedBank.beneficiaryName} />
          <BankDetail label="Beneficiary Address" value={selectedBank.beneficiaryAddress} />
          <BankDetail label="Bank Account No" value={selectedBank.accountNo} />
          <BankDetail label="Account Type" value={selectedBank.accountType} />
          <BankDetail label="Bank Name" value={selectedBank.bankName} />
          <BankDetail label="Bank Address" value={selectedBank.bankAddress} />
          {selectedBank.ifscCode && (
            <BankDetail label="Bank IFSC Code" value={selectedBank.ifscCode} />
          )}
          {selectedBank.swiftCode && (
            <BankDetail label="Bank Swift Code" value={selectedBank.swiftCode} />
          )}
          {selectedBank.intermediaryBankName && selectedBank.intermediaryBankSwiftCode && (
            <>
              <BankDetail label="Intermediary Bank Name" value={selectedBank.intermediaryBankName} />
              <BankDetail label="Intermediary Bank Swift Code" value={selectedBank.intermediaryBankSwiftCode} />
            </>
          )}
          {selectedBank.routingNo && (
            <BankDetail label="Bank Routing No" value={selectedBank.routingNo} />
          )}
          {selectedBank.ibanNo && (
            <BankDetail label="Bank Iban No" value={selectedBank.ibanNo} />
          )}
          {selectedBank.refNo && (
            <BankDetail label="Bank Reference No" value={selectedBank.refNo} />
          )}
          {selectedBank.note && (
            <Box sx={{ ...modernBankDetailRow, alignItems: "flex-start" }}>
              <Typography sx={bankDetailLabel}>Note</Typography>
              {/<[a-z][\s\S]*>/i.test(selectedBank.note) ? (
                <Box
                  sx={{ ...bankDetailValue, textAlign: "justify", flex: 1, "& h3,& h4": { margin: "6px 0 4px", fontWeight: 700 }, "& p": { margin: "4px 0" }, "& ul": { paddingLeft: "1.4em", margin: "4px 0" }, "& li": { marginBottom: "4px" }, "& strong": { fontWeight: 700 } }}
                  dangerouslySetInnerHTML={{ __html: selectedBank.note }}
                />
              ) : (
                <Typography sx={{ ...bankDetailValue, textAlign: "justify", flex: 1 }}>
                  {selectedBank.note}
                </Typography>
              )}
            </Box>
          )}
        </Stack>
      ) : (
        <Box sx={emptyState}>
          <AccountBalanceOutlinedIcon sx={emptyIcon} />
          <Typography sx={emptyText}>
            Bank info will appear here when you click DEPOSIT beside a currency.
          </Typography>
        </Box>
      )}
    </Box>
  );

  return (
    <Box sx={pageWrapper}>
      {/* Hero Banner */}
      <Box
        sx={{
          ...heroBanner,
          background: `linear-gradient(135deg, ${btncolor || "#1976d2"} 0%, ${btncolor || "#1976d2"}cc 100%)`,
        }}
      >
        <Box sx={heroContent}>
          <Box sx={heroIconBadge}>
            <PaymentsOutlinedIcon sx={{ color: "#fff", fontSize: 30 }} />
          </Box>
          <Box>
            <Typography sx={heroTitle}>Deposit Funds</Typography>
            <Typography sx={heroSubtitle}>
              Add fiat currency to your wallet by generating a payment order and transferring to the listed bank account
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Fiat Balances + Bank Details */}
      <Box sx={panelsGrid}>
        {renderFiatBalances()}
        {renderBankDetails()}
      </Box>

      {/* Deposit History */}
      <Box sx={historyCard}>
        <Box sx={panelHeader}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
            <Box sx={{ ...panelIconWrap, backgroundColor: `${btncolor}1a`, color: btncolor }}>
              <HistoryOutlinedIcon sx={{ fontSize: 20 }} />
            </Box>
            <Box>
              <Typography sx={panelTitle}>Deposit History</Typography>
              <Typography sx={panelCaption}>
                Your past payment orders, status and invoices
              </Typography>
            </Box>
          </Box>
          <Tooltip title="Check your Pay order date, Pay order number, Amount, Status and Action of the Payment order" arrow>
            <InfoOutlinedIcon sx={infoIconStyle} />
          </Tooltip>
        </Box>
        <Box sx={panelDivider} />

        <DataTable
          columns={["Payorder Date", "Payorder No", "Amount", "Status", "Action"]}
        >
          {invoiceList.map((i, index) => {
            const isConfirmed = i.status === 17;
            const isPending = i.status === 15;
            const formattedAmount = `${getCurrencySymbol(i.currency)} ${i.amount}`;

            return (
              <TableRow key={index} sx={modernTableRow}>
                <TableCell sx={modernCell}>
                  {new Date(i.created).toLocaleString()}
                </TableCell>
                <TableCell
                  sx={{ ...modernCell, ...linkCell, color: btncolor }}
                  onClick={() =>
                    handleShowPaymentOrder(
                      i.order_no, i.fiat_amount, i.bankName, i.accountNo,
                      i.routingNo, i.beneficiaryName, i.swiftCode, i.currency,
                      i.ibanNo, i.ifscCode, i.accountType, i.bankAddress,
                      i.beneficiaryAddress, i.sortCode, i.referenceNumber, i.note,
                      i.bankId, i.intermediaryBankName, i.intermediaryBankSwiftCode
                    )
                  }
                >
                  {i.order_no}
                </TableCell>
                <TableCell sx={{ ...modernCell, fontWeight: 600 }}>
                  {formattedAmount}
                </TableCell>
                <TableCell sx={modernCell}>
                  {renderStatusBadge(i.status)}
                </TableCell>
                <TableCell sx={modernCell}>
                  {isConfirmed ? (
                    <Typography
                      onClick={() => openInvoice(i)}
                      sx={{ ...invoiceLink, color: btncolor }}
                    >
                      <ReceiptLongOutlinedIcon sx={{ fontSize: 16 }} />
                      Invoice
                    </Typography>
                  ) : isPending ? (
                    <Typography sx={mutedText}>Please complete payment</Typography>
                  ) : (
                    <Typography sx={mutedText}>Payment not received</Typography>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </DataTable>
        {totalCount > noOfItemsPerPage && (
          <Box sx={paginationWrap}>
            <Pagination
              count={Math.ceil(totalCount / noOfItemsPerPage)}
              page={pageNo}
              onChange={handlePageChange}
              sx={paginationStyle}
            />
          </Box>
        )}
      </Box>

      {/* Deposit Modal */}
      <ModalContent
        open={isDepositModalOpen}
        onClose={() => setIsDepositModalOpen(false)}
        title="Deposit Funds"
        width="xs"
      >
        <Box sx={depositModalBalance}>
          <Typography sx={depositModalLabel}>
            Current {currencyCode} Balance
          </Typography>
          <Typography sx={depositModalValue}>
            {getCurrencySymbol(currencyCode)} {currencyValue}
          </Typography>
        </Box>

        <TextField
          type="number"
          value={depositAmount}
          onChange={(e) => setDepositAmount(e.target.value)}
          label="Enter Deposit Amount"
          fullWidth
          variant="outlined"
          sx={modernModalField}
        />

        <Box sx={limitInfoBox}>
          <InfoOutlinedIcon sx={{ fontSize: 14, opacity: 0.7 }} />
          <Typography sx={limitInfoText}>
            {`Minimum ${getCurrencySymbol(currencyCode)} ${getCurrentLimits().rawMin} • Maximum ${getCurrencySymbol(currencyCode)} ${getCurrentLimits().rawMax}`}
          </Typography>
        </Box>

        {showIncreaseLimit && (
          <Link to="/identity-verification" className="no-underline" style={{ border: "none" }}>
            <Box display="flex" justifyContent="center" sx={{ mb: 2 }}>
              <ContainedButton
                variant="outlined"
                sx={modernModalSecondaryBtn}
              >
                Increase Limit
              </ContainedButton>
            </Box>
          </Link>
        )}

        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <ContainedButton
            variant="contained"
            color="success"
            fullWidth
            sx={modernModalPrimaryBtn}
            disabled={isDepositDisabled()}
            onClick={handleDepositAmount}
          >
            Generate Payment Order
          </ContainedButton>
        </Box>
      </ModalContent>

      {/* Payment Order Modal */}
      <Dialog
        open={showPaymentOrderModal}
        onClose={() => setShowPaymentOrderModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: modernDialogPaper }}
      >
        <DialogTitle sx={modernDialogTitle}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
            <ReceiptLongOutlinedIcon sx={{ color: btncolor }} />
            <Typography sx={dialogTitleText}>Payment Order Generated</Typography>
          </Box>
          <IconButton onClick={() => setShowPaymentOrderModal(false)} size="small" sx={dialogCloseBtn}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={modernDialogContent}>
          <Box sx={orderNoBlock}>
            <Typography sx={orderNoLabel}>Order No</Typography>
            <Typography sx={{ ...orderNoValue, color: btncolor }}>
              {displableOrderNo}
            </Typography>
            <Typography sx={orderNoHint}>
              Please complete the transfer within 72 hours to the account below.
            </Typography>
          </Box>

          <Grid container spacing={1.25} sx={{ mt: 1 }}>
            {[
              { label: "Beneficiary Name", value: displableBeneficiaryName },
              { label: "Beneficiary Address", value: displableBeneficiaryAddress },
              { label: "Bank Account No", value: displableAccNo },
              { label: "Account Type", value: displableAccountType },
              { label: "Routing No", value: displableRoutingNo },
              { label: "Sort Code", value: displableSortCode },
              { label: "Bank Name", value: displableBankName },
              { label: "Bank Address", value: displableBankAddress },
              { label: "Reference/Memo", value: referencenumber },
            ].map((item, index) =>
              item.value ? (
                <InvoiceDetail key={index} label={item.label} value={item.value} />
              ) : null
            )}

            {displableSwiftCode && (
              <InvoiceDetail label="Bank Swift Code" value={displableSwiftCode} />
            )}
            {displableIbanNo && (
              <InvoiceDetail label="IBAN" value={displableIbanNo} />
            )}
            {displableIfscCode && (
              <InvoiceDetail label="IFSC" value={displableIfscCode} />
            )}
            {displableIntermediaryBankName && (
              <InvoiceDetail label="Intermediary Bank Name" value={displableIntermediaryBankName} />
            )}
            {displableIntermediaryBankSwiftCode && (
              <InvoiceDetail label="Intermediary Bank Swift Code" value={displableIntermediaryBankSwiftCode} />
            )}
            {note && (
              <InvoiceDetail label="Note" value={note} />
            )}
          </Grid>

          <Box sx={noticeBlock}>
            <Typography sx={noticeText}>
              <strong>*</strong> Please include <strong>only</strong> the{" "}
              <strong>order number</strong> in the payment reference field for your deposit to be credited promptly.
            </Typography>
            <Typography sx={noticeText}>
              <strong>*</strong> The request will expire in <strong>72 hours.</strong>
            </Typography>
            <Typography sx={noticeText}>
              <strong>*</strong> The <strong>name</strong> and <strong>account number</strong> for the transfer should match details given on the website.
            </Typography>
            {currencyCode === "INR" ? (
              <Typography sx={noticeText}>
                <strong>*</strong> All transactions with incorrect details or towards expired requests will be refunded in 15 business days after deducting processing fees.
              </Typography>
            ) : (
              <Typography sx={noticeText}>
                <strong>*</strong> All transactions with incorrect details or towards expired requests will be refunded in 15 business days after deducting {getCurrencySymbol(displayableCurrencyCode || currencyCode)} 15 towards processing fees.
              </Typography>
            )}
          </Box>

          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <ContainedButton
              variant="contained"
              color="success"
              onClick={() => setShowPaymentOrderModal(false)}
              sx={modernModalPrimaryBtn}
            >
              OK
            </ContainedButton>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Invoice Modal */}
      {showInvoice && invoiceData && (
        <Dialog
          open={showInvoice}
          onClose={() => setShowInvoice(false)}
          fullWidth
          maxWidth="xs"
          PaperProps={{ sx: modernDialogPaper }}
        >
          <DialogTitle sx={modernDialogTitle}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
              <ReceiptLongOutlinedIcon sx={{ color: btncolor }} />
              <Typography sx={dialogTitleText}>Invoice</Typography>
            </Box>
            <IconButton onClick={() => setShowInvoice(false)} size="small" sx={dialogCloseBtn}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={modernDialogContent}>
            <Stack spacing={1.25} sx={{ mt: 1 }}>
              <Box sx={modernInvoiceRow}>
                <Typography sx={invoiceRowLabel}>Order No</Typography>
                <Typography sx={invoiceRowValue}>{invoiceData.invoiceOrderNoI}</Typography>
              </Box>
              <Box sx={modernInvoiceRow}>
                <Typography sx={invoiceRowLabel}>Status</Typography>
                <Box sx={{ ...statusBadge, color: "#16a34a", backgroundColor: "rgba(22,163,74,0.10)", borderColor: "rgba(22,163,74,0.25)" }}>
                  <CheckCircleOutlineIcon sx={{ fontSize: 14 }} />
                  CONFIRMED
                </Box>
              </Box>
              {[
                { label: "Beneficiary Name", value: invoiceData.beneficiaryNameI },
                { label: "Beneficiary Address", value: invoiceData.beneficiaryAddressI },
                { label: "Bank Account No", value: invoiceData.accountNoI },
                { label: "Account Type", value: invoiceData.accountTypeI },
                { label: "Routing No", value: invoiceData.routingNoI },
                { label: "Sort Code", value: invoiceData.sortCodeI },
                { label: "Bank Name", value: invoiceData.bankNameI },
                { label: "Bank Address", value: invoiceData.bankAddressI },
                { label: "Reference/Memo", value: invoiceData.referenceNumberI },
                { label: "Bank Swift Code", value: invoiceData.swiftCodeI },
                { label: "IBAN", value: invoiceData.ibanNoI },
                { label: "IFSC", value: invoiceData.ifscCodeI },
                { label: "Intermediary Bank Name", value: invoiceData.intermediaryBankNameI },
                { label: "Intermediary Bank Swift Code", value: invoiceData.intermediaryBankSwiftCodeI },
                { label: "Note", value: invoiceData.noteI },
              ].map((item, index) =>
                item.value ? (
                  <Box key={index} sx={item.label === "Note" ? { ...modernInvoiceRow, alignItems: "flex-start" } : modernInvoiceRow}>
                    <Typography sx={invoiceRowLabel}>{item.label}</Typography>
                    {item.label === "Note" ? (
                      /<[a-z][\s\S]*>/i.test(item.value) ? (
                        <Box sx={{ ...invoiceRowValue, textAlign: "left", flex: 1, "& h3,& h4": { margin: "6px 0 4px", fontWeight: 700 }, "& p": { margin: "4px 0" }, "& ul": { paddingLeft: "1.4em", margin: "4px 0" }, "& li": { marginBottom: "4px" }, "& strong": { fontWeight: 700 } }} dangerouslySetInnerHTML={{ __html: item.value }} />
                      ) : (
                        <Typography sx={{ ...invoiceRowValue, textAlign: "left", flex: 1, whiteSpace: "pre-line" }}>{item.value}</Typography>
                      )
                    ) : (
                      <Typography sx={invoiceRowValue}>{item.value}</Typography>
                    )}
                  </Box>
                ) : null
              )}
              <Box sx={{ ...modernInvoiceRow, ...totalRow }}>
                <Typography sx={{ ...invoiceRowLabel, fontSize: "0.95rem" }}>Total Amount</Typography>
                <Typography sx={{ ...invoiceRowValue, fontSize: "1.05rem", color: btncolor }}>
                  {getCurrencySymbol(invoiceData?.currency)} {invoiceData.invoiceAmountI}
                </Typography>
              </Box>
            </Stack>
          </DialogContent>

          <DialogActions sx={modernDialogActions}>
            <ContainedButton
              variant="contained"
              onClick={() => setShowInvoice(false)}
              sx={modernModalPrimaryBtn}
            >
              OK
            </ContainedButton>
          </DialogActions>
        </Dialog>
      )}

      {/* Bank Verification Warning */}
      <Dialog
        open={dipositeBankWarning}
        onClose={() => setDipositeBankWarning(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: modernDialogPaper }}
      >
        <DialogTitle sx={modernDialogTitle}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
            <VerifiedUserOutlinedIcon sx={{ color: btncolor }} />
            <Typography sx={dialogTitleText}>Verify Bank Info</Typography>
          </Box>
          <IconButton onClick={() => setDipositeBankWarning(false)} size="small" sx={dialogCloseBtn}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={modernDialogContent}>
          <Typography sx={warningHeading}>
            Verified Bank Info is required to make deposits
          </Typography>
          <Typography sx={warningBody}>
            Your Bank Info is either not submitted by you or is pending verification with us or is rejected and requires to be resubmitted. Deposits can be processed once we have your Bank Info verified.
          </Typography>
          <Typography sx={{ ...warningBody, fontStyle: "italic", mt: 2 }}>
            If you have not submitted your Bank Info yet:
          </Typography>
          <Typography sx={warningBody}>
            Click on the drop down beside your name on the right hand top corner. Then click on Bank Info to go to the Bank Info page. Fill in the information of the bank you will use to deposit or withdrawal fiat currency, then hit the SAVE CHANGES button. Then allow some time for the verification to complete.
          </Typography>
          <Typography sx={{ ...warningBody, fontStyle: "italic", mt: 2 }}>
            If you have submitted your Bank Info:
          </Typography>
          <Typography sx={warningBody}>
            Kindly allow 24 hours for us to verify your bank info. If it is taking longer, you can email us at support@paybito.com. You can check the status of the verification on the Bank Info page.
          </Typography>
          <Typography sx={warningBody}>
            You can click OK to be redirected to the Bank Info page.
          </Typography>
        </DialogContent>

        <DialogActions sx={modernDialogActions}>
          <ContainedButton
            variant="contained"
            onClick={() => handleBankDetailsAdd()}
            sx={modernModalPrimaryBtn}
          >
            OK
          </ContainedButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

// 🎨 Theme-aware Styling (uses CSS variables from App.js)
const pageWrapper = {
  px: { xs: 2, md: 4 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};

const heroBanner = {
  borderRadius: "18px",
  px: { xs: 3, md: 4 },
  py: { xs: 3, md: 3.5 },
  mb: 3,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
};

const heroContent = {
  display: "flex",
  alignItems: "center",
  gap: 2,
};

const heroIconBadge = {
  width: 56,
  height: 56,
  borderRadius: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.25)",
  backdropFilter: "blur(6px)",
  flexShrink: 0,
};

const heroTitle = {
  fontSize: { xs: "1.4rem", md: "1.7rem" },
  fontWeight: 700,
  color: "#fff",
  lineHeight: 1.15,
  letterSpacing: "-0.015em",
};

const heroSubtitle = {
  fontSize: { xs: "0.82rem", md: "0.9rem" },
  color: "rgba(255,255,255,0.88)",
  mt: 0.5,
  maxWidth: 640,
};

const panelsGrid = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
  gap: 2.5,
  mb: 3,
};

const panelCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 6px 18px rgba(0,0,0,0.04)",
  p: { xs: 2.25, md: 2.75 },
  display: "flex",
  flexDirection: "column",
};

const panelHeader = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1,
};

const panelIconWrap = {
  width: 38,
  height: 38,
  borderRadius: "11px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const panelTitle = {
  fontSize: "1.05rem",
  fontWeight: 700,
  color: "var(--text-color)",
  lineHeight: 1.2,
};

const panelCaption = {
  fontSize: "0.78rem",
  color: "var(--text-color)",
  opacity: 0.65,
  mt: 0.25,
};

const panelDivider = {
  height: "1px",
  backgroundColor: "rgba(125,125,125,0.15)",
  my: 2,
};

const infoIconStyle = {
  fontSize: 18,
  color: "var(--text-color)",
  opacity: 0.5,
  cursor: "help",
};

const fiatTableHead = {
  display: "grid",
  gridTemplateColumns: "1.2fr 1fr 1.2fr",
  alignItems: "center",
  px: 1.5,
  pb: 1,
};

const fiatHeadCell = {
  fontSize: "0.7rem",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.65,
};

const fiatRow = {
  display: "grid",
  gridTemplateColumns: "1.2fr 1fr 1.2fr",
  alignItems: "center",
  px: 1.5,
  py: 1.25,
  borderRadius: "12px",
  backgroundColor: "var(--body-color-less2)",
  border: "1px solid rgba(125,125,125,0.10)",
  transition: "all 0.15s ease",
  "&:hover": {
    borderColor: "rgba(125,125,125,0.20)",
    transform: "translateY(-1px)",
  },
};

const fiatCellLeft = {
  display: "flex",
  alignItems: "center",
  gap: 1.25,
  minWidth: 0,
};

const currencyAvatar = {
  width: 32,
  height: 32,
  borderRadius: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
  fontSize: "0.85rem",
  flexShrink: 0,
};

const currencyCodeText = {
  fontSize: "0.9rem",
  fontWeight: 600,
  color: "var(--text-color)",
};

const balanceText = {
  fontSize: "0.9rem",
  fontWeight: 600,
  color: "var(--text-color)",
};

const fiatActionCell = {
  display: "flex",
  justifyContent: "flex-end",
};

const depositActionBtn = {
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.78rem",
  px: 2,
  height: 34,
  borderRadius: "9px",
  whiteSpace: "nowrap",
};

const restrictedBtn = {
  textTransform: "none",
  fontSize: "0.72rem",
  height: 34,
  borderRadius: "9px",
  whiteSpace: "nowrap",
};

const modernBankDetailRow = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1.5,
  px: 1.5,
  py: 1.1,
  borderRadius: "10px",
  backgroundColor: "var(--body-color-less2)",
  border: "1px solid rgba(125,125,125,0.10)",
};

const bankDetailLabel = {
  fontSize: "0.75rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.7,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  whiteSpace: "nowrap",
  flexShrink: 0,
};

const bankDetailValueWrap = {
  display: "flex",
  alignItems: "center",
  gap: 0.5,
  minWidth: 0,
  flex: 1,
  justifyContent: "flex-end",
};

const bankDetailValue = {
  fontSize: "0.85rem",
  fontWeight: 600,
  color: "var(--text-color)",
  textAlign: "right",
  wordBreak: "break-word",
};

const bankDetailCopyBtn = {
  color: "var(--text-color)",
  opacity: 0.5,
  flexShrink: 0,
  "&:hover": { opacity: 1, backgroundColor: "rgba(125,125,125,0.10)" },
};

const historyCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 6px 18px rgba(0,0,0,0.04)",
  p: { xs: 2.25, md: 2.75 },
};

const modernTableRow = {
  backgroundColor: "var(--body-color-less)",
  transition: "background-color 0.15s ease",
  "&:hover": { backgroundColor: "var(--body-color-less2)" },
};

const modernCell = {
  fontSize: "0.85rem",
  py: 1.5,
  color: "var(--text-color)",
  borderBottom: "1px solid rgba(125,125,125,0.12)",
};

const linkCell = {
  fontWeight: 600,
  cursor: "pointer",
  textDecoration: "none",
  "&:hover": { textDecoration: "underline" },
};

const statusBadge = {
  display: "inline-flex",
  alignItems: "center",
  gap: 0.5,
  px: 1.1,
  py: 0.4,
  borderRadius: "999px",
  border: "1px solid",
  fontSize: "0.72rem",
  fontWeight: 700,
  letterSpacing: "0.02em",
};

const invoiceLink = {
  display: "inline-flex",
  alignItems: "center",
  gap: 0.5,
  fontSize: "0.85rem",
  fontWeight: 600,
  cursor: "pointer",
  "&:hover": { textDecoration: "underline" },
};

const mutedText = {
  fontSize: "0.82rem",
  color: "var(--text-color)",
  opacity: 0.65,
};

const emptyState = {
  textAlign: "center",
  py: 5,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 1,
};

const emptyIcon = {
  fontSize: 44,
  color: "var(--text-color)",
  opacity: 0.35,
};

const emptyText = {
  fontSize: "0.88rem",
  color: "var(--text-color)",
  opacity: 0.65,
};

const paginationWrap = {
  display: "flex",
  justifyContent: "center",
  mt: 2.5,
};

const paginationStyle = {
  "& .MuiPaginationItem-root": {
    color: "var(--text-color)",
    borderColor: "rgba(125,125,125,0.25)",
  },
  "& .Mui-selected": {
    backgroundColor: "rgba(125,125,125,0.18) !important",
  },
};

// Modal / Dialog styles
const modernDialogPaper = {
  borderRadius: "16px",
  backgroundColor: "var(--popupbody-color)",
  color: "var(--text-color)",
  boxShadow: "0 24px 60px rgba(0,0,0,0.28)",
  border: "1px solid rgba(125,125,125,0.15)",
  overflow: "hidden",
};

const modernDialogTitle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  px: 3,
  py: 2,
  backgroundColor: "var(--popupheader-color)",
  borderBottom: "1px solid rgba(125,125,125,0.15)",
};

const dialogTitleText = {
  fontSize: "1.1rem",
  fontWeight: 700,
  color: "var(--text-color)",
};

const dialogCloseBtn = {
  color: "var(--text-color)",
  opacity: 0.7,
  "&:hover": { opacity: 1, backgroundColor: "rgba(125,125,125,0.10)" },
};

const modernDialogContent = {
  px: 3,
  py: 3,
  backgroundColor: "var(--popupbody-color)",
  color: "var(--text-color)",
};

const modernDialogActions = {
  justifyContent: "center",
  px: 3,
  pb: 3,
  pt: 0,
  backgroundColor: "var(--popupbody-color)",
};

const depositModalBalance = {
  textAlign: "center",
  py: 2,
  px: 2,
  mb: 2,
  borderRadius: "12px",
  backgroundColor: "var(--body-color-less2)",
  border: "1px solid rgba(125,125,125,0.15)",
};

const depositModalLabel = {
  fontSize: "0.78rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.7,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
};

const depositModalValue = {
  fontSize: "1.5rem",
  fontWeight: 700,
  color: "var(--text-color)",
  mt: 0.5,
};

const modernModalField = {
  mb: 1.5,
  "& .MuiInputBase-root": {
    borderRadius: "10px",
    backgroundColor: "var(--body-color)",
    color: "var(--text-color)",
  },
  "& .MuiInputBase-input": { color: "var(--text-color)" },
  "& .MuiInputLabel-root": { color: "var(--text-color)", opacity: 0.7 },
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(125,125,125,0.25)" },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.45)",
  },
};

const limitInfoBox = {
  display: "flex",
  alignItems: "center",
  gap: 0.75,
  px: 1.5,
  py: 1,
  borderRadius: "10px",
  backgroundColor: "var(--body-color-less2)",
  mb: 2,
};

const limitInfoText = {
  fontSize: "0.78rem",
  color: "var(--text-color)",
  opacity: 0.8,
};

const modernModalPrimaryBtn = {
  py: 1.3,
  px: 4,
  borderRadius: "10px",
  fontWeight: 700,
  fontSize: "0.88rem",
  textTransform: "none",
  minWidth: 200,
};

const modernModalSecondaryBtn = {
  py: 1.1,
  px: 3,
  borderRadius: "10px",
  fontWeight: 600,
  fontSize: "0.85rem",
  textTransform: "none",
};

const orderNoBlock = {
  textAlign: "center",
  py: 2,
  px: 2,
  borderRadius: "12px",
  backgroundColor: "var(--body-color-less2)",
  border: "1px solid rgba(125,125,125,0.15)",
};

const orderNoLabel = {
  fontSize: "0.72rem",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.7,
};

const orderNoValue = {
  fontSize: "1.4rem",
  fontWeight: 800,
  letterSpacing: "0.02em",
  mt: 0.5,
  wordBreak: "break-all",
};

const orderNoHint = {
  fontSize: "0.78rem",
  color: "var(--text-color)",
  opacity: 0.7,
  mt: 1,
};

const modernInvoiceRow = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1.5,
  px: 1.5,
  py: 1.1,
  borderRadius: "10px",
  backgroundColor: "var(--body-color-less2)",
  border: "1px solid rgba(125,125,125,0.10)",
  width: "100%",
};

const invoiceRowLabel = {
  fontSize: "0.78rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.7,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  whiteSpace: "nowrap",
  flexShrink: 0,
};

const invoiceRowValue = {
  fontSize: "0.88rem",
  fontWeight: 700,
  color: "var(--text-color)",
  textAlign: "right",
  wordBreak: "break-word",
  flex: 1,
};

const totalRow = {
  borderTop: "2px solid rgba(125,125,125,0.20)",
  mt: 1,
  pt: 1.5,
  backgroundColor: "transparent",
  border: "none",
  borderRadius: 0,
};

const noticeBlock = {
  mt: 3,
  p: 2,
  borderRadius: "10px",
  backgroundColor: "var(--body-color-less2)",
  border: "1px solid rgba(125,125,125,0.12)",
};

const noticeText = {
  fontSize: "0.78rem",
  color: "var(--text-color)",
  opacity: 0.85,
  lineHeight: 1.55,
  mb: 0.75,
  "&:last-child": { mb: 0 },
};

const warningHeading = {
  fontSize: "1.05rem",
  fontWeight: 700,
  color: "var(--text-color)",
  mb: 1.5,
};

const warningBody = {
  fontSize: "0.88rem",
  color: "var(--text-color)",
  opacity: 0.85,
  lineHeight: 1.6,
};

export default DepositPage;

